/* 24GAMEKEYS — gk-epic-force.js (v37.2)
   Filet de securite pour la tuile Epic Games et le lien Epic du menu.

   Pourquoi ce fichier existe :
   "Epic Games" s'affiche au chargement puis disparait chez certains
   visiteurs. Le code serveur a ete verifie de fond en comble (section
   gk-home.liquid, gkx-home-css, les 5 JS du theme, le menu Shopify et le
   HTML reellement servi) : tout est correct cote serveur. La disparition
   vient donc d'un script client-side — app de traduction, extension
   navigateur ou bloqueur — qui masque ou supprime l'element apres le rendu.

   Ce script observe le DOM et remet la tuile/le lien en etat si quelque
   chose les masque ou les retire. Il ne cree jamais d'element en double :
   il ne fait que restaurer ce que le serveur a deja envoye.

   Si le probleme est definitivement resolu a la source (app desinstallee,
   filtre corrige), ce fichier peut etre retire — mais il est inoffensif. */
(function () {
  'use strict';

  var EPIC_SEL = 'a[href*="/collections/epic-games"]';

  function restore(el) {
    if (!el) return;
    var s = el.style;
    // Ne rien faire si l'element est deja visible : on evite les writes inutiles
    if (s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0') {
      var cs = window.getComputedStyle(el);
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0') return;
    }
    s.setProperty('display', el.classList.contains('gkx-portal') ? 'flex' : 'flex', 'important');
    s.setProperty('visibility', 'visible', 'important');
    s.setProperty('opacity', '1', 'important');
    s.setProperty('pointer-events', 'auto', 'important');
  }

  function sweep() {
    document.querySelectorAll(EPIC_SEL).forEach(restore);
  }

  function init() {
    sweep();

    // Re-verifie a chaque mutation du DOM (apps de traduction, bloqueurs, etc.)
    try {
      var mo = new MutationObserver(function () { sweep(); });
      mo.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden']
      });
    } catch (e) {}

    // Filet supplementaire : quelques passages differes pour les scripts lents
    [300, 1000, 2500, 5000].forEach(function (ms) { setTimeout(sweep, ms); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
